export const UserActionTypes = {
    SET_CURRENT_USER: 'SET_CURRENT_USER'
};

// we do this kind of file so we don't have accidental typos